import { render, staticRenderFns } from "./SpotPricing.vue?vue&type=template&id=5b032e8d&scoped=true"
import script from "./SpotPricing.vue?vue&type=script&lang=js"
export * from "./SpotPricing.vue?vue&type=script&lang=js"
import style0 from "./SpotPricing.vue?vue&type=style&index=0&id=5b032e8d&prod&scoped=true&lang=css"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "5b032e8d",
  null
  
)

export default component.exports